'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var availableThemes = ['blue', 'lavender', 'navy', 'pink', 'turquoise'];

var ToggleBarButtons = (0, _react.memo)(function (_ref) {
	var className = _ref.className,
	    selected = _ref.selected,
	    dataset = _ref.dataset,
	    showAllButton = _ref.showAllButton,
	    allLabel = _ref.allLabel,
	    multiple = _ref.multiple,
	    theme = _ref.theme,
	    onChange = _ref.onChange;


	var _dataset = multiple && showAllButton ? [].concat(_toConsumableArray(dataset), [{
		label: allLabel,
		value: '_all'
	}]) : dataset;

	var _theme = availableThemes.includes(theme) ? theme : 'blue';

	var getItemFromValue = function getItemFromValue(value) {
		if (value === '_all') return null;

		var ob = dataset.find(function (d) {
			return d.value.toString() === value.toString();
		});
		if (!ob) {
			console.error("[ToggleBarButtons] Value", value, "not found in dataset"); //eslint-disable-line
			return null;
		}

		return ob;
	};

	var onClick = function onClick(value) {
		return function () {
			if (value === null || value === "") return null;

			if (multiple && value === '_all') {
				// Select all values
				onChange({ selected: dataset.map(function (d) {
						return d.value;
					}), type: 'toggle-bar-buttons' });
			} else {
				var ob = getItemFromValue(value);
				if (!ob) return null;

				if (!multiple) {
					onChange({ item: ob, selected: value, type: 'toggle-bar-buttons' });
				} else {
					var newSelected = selected.indexOf(ob.value) === -1 ? [].concat(_toConsumableArray(selected), [ob.value]) : selected.filter(function (s) {
						return s !== ob.value;
					});

					onChange({ item: ob, selected: newSelected, type: 'toggle-bar-buttons' });
				}
			}
		};
	};

	return _react2.default.createElement(
		'div',
		{ className: (0, _classnames2.default)('bnc_field_toggle-bar-buttons', className) },
		_dataset.map(function (item, index) {
			return (item.value !== "_all" || item.value === '_all' && showAllButton && multiple) && _react2.default.createElement(
				'button',
				{
					className: (0, _classnames2.default)('bnc_field_toggle-bar-buttons--item', 'theme--' + _theme, {
						'active': multiple ? selected.findIndex(function (s) {
							return s === item.value;
						}) > -1 : selected === item.value
					}),
					onClick: onClick(item.value),
					key: item.value + '-' + index
				},
				_react2.default.createElement(
					'span',
					null,
					item.label
				)
			);
		})
	);
});

ToggleBarButtons.defaultProps = {
	showAllButton: false,
	allLabel: 'All',
	multiple: false,
	theme: 'blue'
};

ToggleBarButtons.propTypes = {
	showAllButton: _propTypes2.default.bool,
	allLabel: _propTypes2.default.string,
	multiple: _propTypes2.default.bool,
	theme: _propTypes2.default.string,
	selected: _propTypes2.default.oneOfType([_utils.StringOrNumber, _propTypes2.default.arrayOf(_utils.StringOrNumber)]).isRequired,
	dataset: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		value: _utils.StringOrNumber.isRequired,
		label: _utils.StringOrReact.isRequired
	})).isRequired,
	onChange: _propTypes2.default.func,
	className: _propTypes2.default.string
};

exports.default = ToggleBarButtons;